App.BonusLogBlockComponent = Em.Component.extend
  classNames: 'bonus-log-block'
  store: Em.inject.service('store')
  env: Em.inject.service('environment')

  order: null

  orderObserver: (->
    return unless @get('log.order_id')
    @get('store').find('order', @get('log.order_id'))
    .then (order) =>
      @set('order', order)
  ).observes('log.order_id').on('init')

  isPositive: (->
    @get('log.amount') > 0
  ).property('log.amount')

  formattedBonusesCount: (->
    amount = @get('log.amount')
    Math.abs(amount)
  ).property('log.amount')

  formattedBonusesValue: (->
    amount = @get('log.amount')
    numeral(amount).format(if amount > 0 then '+0,0.0' else '0,0.0')
  ).property('log.amount')